<artemis-breadcrumbs [breadcrumbs]="breadcrumbs"></artemis-breadcrumbs>
<artemis-user-notifications-component *ngIf="!defaultUsersCardActive" (defaultUsersSaved)="toggleUsersCards()" [showResetButton]="false">
</artemis-user-notifications-component>
<div class="default-users-card" *ngIf="defaultUsersCardActive">
  <artemis-loading-spinner *ngIf="defaultUsersListLoading$ | async"></artemis-loading-spinner>
  <div class="default-users-card__content-container">
    <div class="default-users-card__btn-container">
      <button mat-button class="btn btn_rounded btn_small default-users-card__toggle-btn" ubi-round-button
              (click)="updateDefaultSettings()">
        {{ 'customer_info.button.update' | translate }}
      </button>
      <button mat-button class="btn btn_accent-gradient-rounded btn_small default-users-card__toggle-btn" ubi-round-button
              (click)="toggleUsersCards()">
        {{ 'customer_info.button.change' | translate }}
      </button>
    </div>
  </div>
</div>
<div class="details-form-card">
  <div ubi-curve-header class="details-form-card__header">
    <span class="details-form-card__header-text"> {{ 'customer_info.header' | translate }} </span>
  </div>
  <artemis-popover>
    <ng-container *ngFor="let section of ('customer_info.info.content' | translate)">
      <ng-container *ngFor="let content of section.paragraph">
        <p>{{content}}</p>
      </ng-container>
    </ng-container>
  </artemis-popover>
  <div class="details-form-card__content-container">
    <artemis-loading-spinner *ngIf="(customerLoading$ | async) || formLoading"></artemis-loading-spinner>
    <artemis-details-form (formDataChanged)="childDataChanged($event)" (loading)="formLoadingHandler($event)" [isPrimary]="true" [isSearch]="true" [dataAvaliableFormFields]="dataAvaliableFormFields"></artemis-details-form>
    <div class="details-form-card__btns-container">
      <div class="details-form-card__msg-container">
        <div class="details-form-card__hint-msg">
          <div *ngIf="hasFormerOrAliasName()"> {{ 'customer_info.message.alias_or_former_name_credit_consumption' | translate }} </div>
        </div>
        <div class="details-form-card__error-msg" [hidden]="!triedSubmit">
          <div [hidden]="isFormValid()"> {{ 'customer_info.message.is_required' | translate }} </div>
          <div [hidden]="isNotifyUserValid()"> {{ 'customer_info.message.is_notify' | translate }} </div>
        </div>
      </div>
      <button mat-button class="btn btn_rounded details-form-card__submit-btn" ubi-round-button
              [disabled]="(customerLoading$ | async)" (click)="registerNewCustomer()">
        {{ 'customer_info.button.save_as_draft' | translate }}
      </button>
      <button mat-button class="btn btn_accent-gradient-rounded details-form-card__submit-btn" ubi-round-button *ngIf="customerType === 'CORPORATE'"
              [disabled]="(customerLoading$ | async)" (click)="registerNewCustomer('crp')">
        {{ 'customer_info.button.save_end_add_crp' | translate }}
      </button>
      <button mat-button class="btn btn_accent-gradient-rounded details-form-card__submit-btn" ubi-round-button
              [disabled]="(customerLoading$ | async)" (click)="registerNewCustomer('ra')">
        {{ 'customer_info.button.completed' | translate }}
      </button>
    </div>
  </div>
</div>
